import { NgModule } from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {FxRateRoutes} from './fx-rate.routes';
import {RouterModule} from '@angular/router';
import { AddFxRateReportComponent } from './components/add-fx-rate-report/add-fx-rate-report.component';
import { FxRateReportContentComponent } from './components/fx-rate-report-content/fx-rate-report-content.component';
import { FxRateViewReportComponent } from './components/fx-rate-view-report/fx-rate-view-report.component';
import { ReportSettingsFormComponent } from './components/report-settings-form/report-settings-form.component';
import { FxRateCurrencySelectorComponent } from './components/fx-rate-currency-selector/fx-rate-currency-selector.component';
import {FxRateApiService} from './services/fx-rate-api.service';
import {StoreModule} from '@ngrx/store';
import {fxRateReducer} from './store/reducers/fx-rate.reducer';
import {EffectsModule} from '@ngrx/effects';
import {FxRateEffect} from './store/effects/fx-rate.effect';
import {FxRateDynamicComponentHelper} from "./fx-rate-dynamic-component-helper";
import { PlatformCommand } from '@shared/commands/command-base';
import { CommandService } from '@core/services/command.service';
import { Api } from '@shared/constants/common-field.constants';
import { ItrceFxrateApiProvider } from './services/itrce-fx-rate-api-provider';
import { PlatformApiProvider } from '@shared/services/platform-api-provider';
import {PlatformToolFxRatesHandler} from '@features/fx-rate/services/platform-tool-fx-rates.handler';

@NgModule({
  declarations: [
    AddFxRateReportComponent,
    FxRateReportContentComponent,
    FxRateViewReportComponent,
    ReportSettingsFormComponent,
    FxRateCurrencySelectorComponent
  ],
  imports: [    SharedModule,
    RouterModule.forChild(FxRateRoutes),
    StoreModule.forFeature('fx-rates', fxRateReducer),
    EffectsModule.forFeature([FxRateEffect]),

  ],
  exports: [],
  providers: [FxRateApiService]
})
export class FxRateModule {
  constructor(private commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              private platformToolFxRatesHandler: PlatformToolFxRatesHandler
              ) {
    FxRateDynamicComponentHelper.init();
    FxRateDynamicComponentHelper.register('PlatformToolFxRatesHandler', platformToolFxRatesHandler);
    this.commandService.registrPlatformLinkCommand('orbitax-connect/itrce/fxrates/:magicLinkId', this.getCreateFxRateReportPlatformToolLinkCommand());
    this.platformApiProvider.registerAtTop(new ItrceFxrateApiProvider());

    const FxRatesCommand = new PlatformCommand('FxRatesToolLinkCommand', Api.FxRate);
    this.commandService.registrPlatformLinkCommand('/itrce/fxrates', FxRatesCommand);

    const FxRatesReportCommand = new PlatformCommand('CreateFxRatesReportToolLinkCommand', Api.FxRate);
    this.commandService.registrPlatformLinkCommand('/itrce/fxrates/add-report/:reportID', FxRatesReportCommand);

    const FxRatesViewReportCommand = new PlatformCommand('FxRatesViewReportToolLinkCommand', Api.FxRate);
    this.commandService.registrPlatformLinkCommand('/itrce/fxrates/fx-rates-view-report/:reportName/:reportID', FxRatesViewReportCommand);
  }

  private getCreateFxRateReportPlatformToolLinkCommand() {
    const command = new PlatformCommand('CreateFxRateReportPlatformToolLinkCommand', Api.FxRate);
    command.projectId = '[PROJECT_ID]';

    return command;
  }
}
